import { render, staticRenderFns } from "./DetailAlert.vue?vue&type=template&id=662427df&"
import script from "./DetailAlert.vue?vue&type=script&lang=js&"
export * from "./DetailAlert.vue?vue&type=script&lang=js&"
import style0 from "./DetailAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports